import styled from '@emotion/styled';

interface Props {
    checked?: boolean;
}

const Icon = styled.div<{ checked: boolean }>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #000;
    background-color: ${({ checked }) => (checked ? '#000' : '#fff')}; /* チェックされている場合の背景色を指定 */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &:after {
        content: '';
        width: 12px;
        height: 12px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        display: ${({ checked }) => (checked ? 'block' : 'none')}; /* チェックされている場合にチェックマークを表示 */
        position: absolute;
        transform: rotate(45deg);
        top: 4px;
        left: 8px;
    }
`;

/**
 * 丸い形のチェックマーク
 */
export const CheckMark: React.FC<Props> = ({ checked = false }) => {
    return <Icon checked={checked} />;
};
